export enum ZoomEnum {
    x1 = 1,
    x2 = 2,
    x3 = 3,
    x4 = 4,
    x6 = 6
}
